<template>
  <v-checkbox
    v-model="$data[opts.key]"
    :name="opts.key"
    color="primary"
  >
    <template v-slot:label>
      <small>{{ label }}</small>
    </template>
    <template v-slot:append>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        {{ description }}
      </v-tooltip>
    </template>
  </v-checkbox>
</template>
<script>
export default {
  name: "BotCheckbox",
  props: {
    opts: {
      type: Object,
      default() {
        return {};
      }
    },
    config: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    let data = {};
    let key = this.opts.key;
    data[key] = null;
    return data;
  },
  computed: {
    label() {
      return (
        this.opts.name[this.$i18n.locale] +
        (this.opts.required != undefined && this.opts.required == true
          ? "*"
          : "")
      );
    },
    description() {
      return this.opts.description[this.$i18n.locale];
    }
  },
  mounted() {
    if (this.config != null) this.$data[this.opts.key] = this.config;
  },
  methods: {}
};
</script>